import { memo } from 'react'

import styled from 'styled-components'

import { Button, ButtonFace, ButtonSize } from '../Button'
import { Options } from './Options'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  hideLabels?: boolean
  onPageChange: (page: number, size: number) => void
  blockPagination?: () => void
  size?: number | null
  page?: number | null
  total?: number | null
  buttonSize?: ButtonSize
  className?: string
  disabled?: boolean
  withSize?: boolean
  sizeOptions?: string[]
  tooMany?: boolean
}

const handlePageChange =
  (onPageChange: { (number: number, size: number): void }, allPages: number, pageSize: number) =>
  (nextPageIndex: number) => {
    if (nextPageIndex <= allPages && nextPageIndex >= 0) {
      onPageChange(nextPageIndex, pageSize)
    }
  }

const Content = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Pagination = memo((props: Props) => {
  const {
    size = 10,
    page = 1,
    total,
    onPageChange,
    buttonSize = ButtonSize.SMALL,
    disabled = false,
    withSize = false,
    sizeOptions,
    blockPagination,
    tooMany = false,
    ...rest
  } = props
  // eslint-disable-next-line
  const items = Boolean(total) ? total : 1
  const allPages =
    items !== null && items !== undefined && size !== null && size !== undefined
      ? Math.floor((items - 1) / size) + 1
      : null
  const pageChanged =
    allPages !== null && size !== null && size !== undefined ? handlePageChange(onPageChange, allPages, size) : null
  const pageSizeChanged = (size: number) =>
    allPages !== null ? handlePageChange(onPageChange, allPages, size)(1) : null

  return (
    <Content {...rest}>
      <Button
        onClick={() => {
          blockPagination && blockPagination()
          if (page !== null && pageChanged) {
            pageChanged(page - 1)
          }
        }}
        face={ButtonFace.SECONDARY}
        size={buttonSize}
        disabled={(page !== null && page <= 1) || disabled}
      >
        Previous
      </Button>
      <Button face={ButtonFace.LINK} size={buttonSize}>
        {page} of {tooMany ? 'too many' : allPages}
      </Button>
      <Button
        onClick={() => {
          blockPagination && blockPagination()
          if (page !== null && pageChanged) {
            pageChanged(page + 1)
          }
        }}
        face={ButtonFace.SECONDARY}
        size={buttonSize}
        disabled={(page !== null && allPages !== null && allPages <= page) || disabled}
      >
        Next
      </Button>
      {withSize && (
        <Options
          disabled={disabled}
          changeSize={pageSizeChanged}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          size={size}
          sizeOptions={sizeOptions}
        />
      )}
    </Content>
  )
})
